/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantDto } from '../../models/backend-opex-variant-dto';
import { BackendOpexVariantRequestDto } from '../../models/backend-opex-variant-request-dto';

export interface SalesOpexVariantsCreate$FormData$Params {
  body: BackendOpexVariantRequestDto;
}

export function salesOpexVariantsCreate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: SalesOpexVariantsCreate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
  const rb = new RequestBuilder(rootUrl, salesOpexVariantsCreate$FormData.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendOpexVariantDto>;
    }),
  );
}

salesOpexVariantsCreate$FormData.PATH = '/api/sales/opex_variants/';
